import { Component } from "vue-property-decorator";
import PageOptions from "../config/PageOptions";
import { UserLoggedInfoModel } from "@/models/userModels";
import baseUserContextComponent from "@/components/baseUserContextComponent";
import { Route } from "vue-router";

@Component({
})
export default class baseUserContextPage extends baseUserContextComponent {

    //getUser!: UserLoggedInfoModel;
    pageOptions = PageOptions;
}
